import { render, staticRenderFns } from "./MoveFlow.vue?vue&type=template&id=fbbb2644"
import script from "./MoveFlow.vue?vue&type=script&lang=ts"
export * from "./MoveFlow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports